/*
 * @Description: 订单中带标题卡片
 */
<template  minapp='mpx' xlang='wxml'>
<es-card-wrap1 custom-style="{{customStyle}}">
  <es-descriptions title="{{title}}" custom-style="{{{padding: '12px 12px 16px'}}}" wx:if="{{title}}">
    <slot />
  </es-descriptions>
  
  
</es-card-wrap1>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      },
      customStyle: {}
    },
    data: {},
    watch: {},
    computed: {},
    methods: {},
    beforeCreate() {},

    created() {},

    mounted() {},

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  .card
    background-color white
    border-radius 8px
    margin 0px 12px
    padding 12px
  .card-title
    font-size 16px
    font-weight bold
    color black
    align-items center
  .card-divider
    width auto
    height 1px
    background-color #ebebeb
    // opacity 0.08
    margin-top 12px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-card-wrap1': '@didi/es-mpx-ui/lib/card/card-wrap1',
      'es-descriptions': '@didi/es-mpx-ui/lib/descriptions',
      'order-inline-info': '@/components/order-inline-info'
    }
  }
</script>